import React from "react";
import MaterialButton, { ButtonProps as MaterialButtonProps } from "@mui/material/Button";
import MaterialFab from "@mui/material/Fab";
import MaterialIconButton from "@mui/material/IconButton";

interface ButtonProps extends MaterialButtonProps {
  mode?: "primary" | "secondary";
  // have to define target since it's supported but not recognized by TS
  target?: string;
  component?: React.ElementType;
}

export const Button = ({ mode = "primary", component = "button", ...rest }: ButtonProps) => {
  const variant = mode === "primary" ? "contained" : "outlined";
  const mergedProps: MaterialButtonProps = {
    variant,
    color: "primary",
    ...rest,
  };
  // component prop comes from OverridableComponent
  return <MaterialButton component={component} {...mergedProps} />;
};

export const IconButton = MaterialIconButton;
export const Fab = MaterialFab;
